import {Component, inject, model, OnInit, signal, ViewChild} from '@angular/core';
import {InputComponent, InputOptions, SwitchComponent, SwitchOptions} from '@shared/components';
import {APIService} from '@core/services';
import {Subject, takeUntil} from 'rxjs';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputModes, InputTypes} from '@core/enums';
import {VaccinationCoding} from '@core/classes/other/vaccination-coding';
import {Product} from '@core/classes/other/product';
import {RadiosComponent, RadiosOptions} from '@shared/components/radios/radios.component';

@Component({
  selector: 'ncp-medication-search',
  imports: [
    FormsModule,
    InputComponent,
    ReactiveFormsModule,
    RadiosComponent
  ],
  templateUrl: './medication-search.component.html',
  styleUrl: './medication-search.component.scss',
})
export class MedicationSearchComponent implements OnInit {
  @ViewChild('searchInput') public searchInput!: InputComponent
  private readonly apiService = inject(APIService)

  protected medicationRadiosOptions = signal<RadiosOptions>({});
  protected brandNameInputOptions = signal<InputOptions>({});
  protected activeSubstanceInputOptions = signal<InputOptions>({});
  protected atcCodeInputOptions = signal<InputOptions>({});

  protected data = model<any>();
  protected isChecked: boolean = true;

  private subscription: any;
  private destroy$ = new Subject<void>();

  protected formGroup: FormGroup = new FormGroup({
    brandNameSearch: new FormControl<string>(''),
    activeSubstanceSearch: new FormControl<string>(''),
    atcCodeSearch: new FormControl<string>(''),
  });

  get brandNameSearch() {
    return this.formGroup.get('brandNameSearch') as FormControl;
  }

  get activeSubstanceSearch() {
    return this.formGroup.get('activeSubstanceSearch') as FormControl;
  }

  get atcCodeSearch() {
    return this.formGroup.get('atcCodeSearch') as FormControl;
  }

  ngOnInit() {
    this.brandNameInputOptions.set(
      new InputOptions({
        id: 'brandNameSearch',
        name: 'brandNameSearch',
        type: InputTypes.text,
        mode: InputModes.search,
        placeholder: 'brand_name',
        initialValue: '',
        formControl: this.brandNameSearch,
        onKeyUp: this.onKeyUp
      })
    );

    this.activeSubstanceInputOptions.set(
      new InputOptions({
        id: 'activeSubstanceSearch',
        name: 'activeSubstanceSearch',
        type: InputTypes.text,
        mode: InputModes.search,
        placeholder: 'active_substance',
        initialValue: '',
        formControl: this.activeSubstanceSearch,
        onKeyUp: this.onKeyUp
      })
    );

    this.atcCodeInputOptions.set(
      new InputOptions({
        id: 'atcCodeSearch',
        name: 'atcCodeSearch',
        type: InputTypes.text,
        mode: InputModes.search,
        placeholder: 'atc_code',
        initialValue: '',
        formControl: this.atcCodeSearch,
        onKeyUp: this.onKeyUp
      })
    );

    this.medicationRadiosOptions = signal<RadiosOptions>(
      new RadiosOptions({
        id: 'medicationRadios',
        value: 0,
        options: [
          {
            value: 0,
            label: 'brand_name'
          },
          {
            value: 1,
            label: 'active_substance'
          },
          {
            value: 2,
            label: 'atc_code'
          }
        ]

      })
    );
  }

  onKeyUp = (event: KeyboardEvent, value: string) => {
    console.log('onKeyUp', (event.target as HTMLInputElement).id + ' ' + this.isChecked);

    var api;

    this.data().onSearch('medication', value);

    switch ((event.target as HTMLInputElement).id) {
      case 'brandNameSearch': {
        api = this.data().api.brandName;
      } break;
      case 'activeSubstanceSearch': {
        api = this.data().api.activeSubstance;
      } break;
      case 'atcCodeSearch': {
        api = this.data().api.atcCode;
      } break;
      default: {
        api = this.data().api.brandName;
      }
    }

    api.body! = {
      description: value
    }

    console.log(this.data().api);
    console.log(api);

    api.body!.description = value;

    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.subscription = this.apiService
      .call(api)
      ?.pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res) {
          console.log(res);
          res.data.map((item: Product) => {
            item.description = item.productName;
          })
          this.data().allData.set(res.data);
        }
      });
  }
}
